module.exports = __webpack_public_path__ + "img/telefono--white.7fe53dac.svg";